import React, {useEffect, useState} from 'react';
import {MenuItem, Select, Typography} from '@material-ui/core';
import SearchAdd from './SearchAdd';
import {IGenericType, IUser} from 'constants/interfaces';
import {ISimpleProduceItem} from '../models';
type CropAndPartiesProps = {
  buyer?: IUser;
  produce?: ISimpleProduceItem;
  variety?: IGenericType;
  onBuyer?: (value?: IUser) => void;
  onProduce?: (value?: ISimpleProduceItem) => void;
  onVariety?: (value?: IGenericType) => void;
};

const CropAndParties = (props: CropAndPartiesProps) => {
  const [varietyOptions, setVarietyOptions] = useState<IGenericType[]>([]);
  useEffect(() => {
    // console.log('produce', props.produce);
    setVarietyOptions(props.produce?.variety ?? []);
  }, [props.produce]);
  useEffect(() => {
    // console.log('buyer', props.buyer);
  }, [props.buyer]);
  return (
    <div>
      <div className="title">Parties and crop</div>
      <div className="row">
        <div className="col-6">
          <Typography>Buyer</Typography>
        </div>
        <div className="col-6">
          <SearchAdd
            onSelect={(value) => props.onBuyer?.(value as any)}
            type="buyer"
            placeholder="Search buyer"
            value={props.buyer?.company?.name}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Typography>Crop</Typography>
        </div>
        <div className="col-6">
          <SearchAdd
            onSelect={(value) => props.onProduce?.(value as any)}
            type="produce"
            placeholder="Search crop"
            value={props.produce?.name}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Typography>Variety</Typography>
        </div>
        <div className="col-6">
          <Select
            value={props.variety?.id}
            onChange={(e) =>
              props.onVariety?.(
                varietyOptions.find((v) => v.id === e.target.value),
              )
            }
            fullWidth
            variant="outlined"
            placeholder="Select variety"
          >
            {varietyOptions.map((variety) => (
              <MenuItem key={variety.id} value={variety.id}>
                {variety.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default CropAndParties;
